import { Component } from '@angular/core';
import { ProgressBarService } from './service/progress-bar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent{
  constructor(public progressBarService: ProgressBarService) {}
}
